import { FC } from "react";
import SalifyFormTextFieldWrapper, {
  SalifyFormTextFieldWrapperProps,
} from "./common/text-field-wrapper";

const SalifyFormTextFieldDefault: FC<SalifyFormTextFieldWrapperProps> = ({
  field,
  textFieldProps,
}) => {
  return <SalifyFormTextFieldWrapper field={field} textFieldProps={textFieldProps} />;
};

SalifyFormTextFieldDefault.displayName = "SalifyTextFieldDefault";

export default SalifyFormTextFieldDefault;
